<ion-header mode="ios">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="dismiss()">
        <ion-icon slot="icon-only" name="chevron-back"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title class="ion-text-center">New message</ion-title>
    <ion-text class="num-symbols" slot="end">Symbols: {{ msg.value.length }}
      ({{ msg.value.length <= 160 ? 1 : (msg.value.length / 153) | math: 'ceil' }})
    </ion-text>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-item lines="none">
    <!-- @if (speechSrv.isSupported) {
      <ion-select slot="end"
                  interface="popover"
                  aria-label="Language"
                  [value]="speechSrv.language$ | async"
                  (ionChange)="changeLanguage($event)"
      >
        <ion-select-option value="{{Lang.DE}}">German</ion-select-option>
        <ion-select-option value="{{Lang.IT}}">Italian</ion-select-option>
        <ion-select-option value="{{Lang.FR}}">French</ion-select-option>
      </ion-select>
    } -->
    <ion-button slot="end" (click)="getTemplate()" [disabled]="!this.recipient.value">
      <ion-icon slot="icon-only" name="document"></ion-icon>
    </ion-button>
  </ion-item>
  <form [formGroup]="messageForm">
    <ion-list>
      <ion-item-divider>Destination:</ion-item-divider>
      @if (recipient.value; as contact) {
        <ion-item class="ion-text-wrap">{{ contact.FULLNAME }} ({{ contact.PHONE }})</ion-item>
      }
      @if (isSelectContact()) {
        <app-select-contact [contacts]="contacts()!" [sender]="recipient.value" (senderChange)="setRecipient($event)">
        </app-select-contact>
      }
      @if (recipient.value) {
        <ion-item-divider>Sender:</ion-item-divider>
        <ion-item>
          <ion-select justify="start"
                      [value]="sender.value"
                      (ionChange)="onGsmNumberChange($event)"
                      [interfaceOptions]="{
                        cssClass: 'sms-destination-select',
                        header: 'Select GSM number:',
                      }"
          >
            @for (gsmNumber of orderedGsmNumbers(); track idx; let idx = $index) {
              <ion-select-option [value]="gsmNumber">
                {{ gsmNumber.GSM_NUMBER }} {{ gsmNumber.DESCRIPTION || '' }}
              </ion-select-option>
            }
          </ion-select>
        </ion-item>
      }
      <ion-item-divider>Message:</ion-item-divider>
      <ion-item lines="full">
        <ion-textarea [autoGrow]="true" placeholder="Enter a text of message" [maxlength]="918" formControlName="msg">
        </ion-textarea>
      </ion-item>
    </ion-list>
    <ion-button expand="block" (click)="sendMessage()" [disabled]="messageForm.invalid">Send</ion-button>
  </form>

  <!-- @if (speechSrv.isSupported) {
    <ion-fab slot="fixed" vertical="bottom" horizontal="end">
      <ion-fab-button (click)="speechToText()" color="{{ isRecording() ? 'danger' : 'primary' }}">
        <ion-icon name="{{ isRecording() ? 'stop' : 'mic-outline' }}"></ion-icon>
      </ion-fab-button>
    </ion-fab>
  } -->
</ion-content>
